/**
 * Created by yuanlei on 2020/1/17.
 */
const UA = navigator.userAgent.toLowerCase();

// 判断微信浏览器
export const WECHAT_BROWSER = UA.includes("micromessenger");



// WEBPACK FOOTER //
// ./src/untils/browser.js